import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { toast } from 'react-hot-toast';
import { RepairIcon } from 'ui-component/custom-icons/icons';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import InputGroup from 'react-bootstrap/InputGroup';

const RepairModalMobile = ({ openPopup, selectedItem, index, handleClose, handleAddRepairs }) => {
    const currencies = [
        { label: 'USD($)', value: 'usd' },
        { label: 'EUR(€)', value: 'eur' },
        { label: 'AED(AED)', value: 'aed' }
    ];

    const [defaultCurrency, setDefaultCurrency] = useState(currencies?.[0]?.label);
    const [selectedRepairType, setSelectedRepairType] = useState(null);
    const [selectedAssginedPerson, setSelectedAssignedPerson] = useState(null);
    const [selectedRepairs, setSelectedRepairs] = useState({
        'operationItemId': selectedItem?.id,
        'repairTypeId': '',
        'repairName': '',
        'repairCurrency': currencies?.[0]?.value,
        'repairCost': '',
        'assignedId': '',
        'assignedName': '',
    });
    const [repairTypes, setRepairTypes] = useState([]);
    const [users, setUsers] = useState([]);

    useEffect(() => {
        api.getSelectOptionsList('standard_repair_types').then((res) => {
            if (res?.data) {
                const repairs = res?.data?.map((item) => { 
                    item.label = item.name;
                    item.value = item.id;
                    return item;
                });
                setRepairTypes(repairs);
            }
        });
    }, []);

    useEffect(() => {
        setSelectedRepairs({
            'operationItemId': selectedItem?.id,
            'repairTypeId': '',
            'repairName': '',
            'repairCurrency': currencies?.[0]?.value,
            'repairCost': '',
            'assignedId': '',
            'assignedName': '',
        });
        setSelectedRepairType(null);
        setSelectedAssignedPerson(null);
    }, [selectedItem]);

    const handleChangeRepair = (e) => {
        setSelectedRepairs({
            ...selectedRepairs,
            'repairTypeId': e?.id,
            'repairName': e?.name
        });
        setSelectedRepairType(e);
    };
    const handleChangeCurrency = (currency) => {
        setSelectedRepairs({
            ...selectedRepairs,
            repairCurrency: currency.value
        });
        setDefaultCurrency(currency.label);
    };

    const handleChangeCost = (e) => {
        const cost = parseFloat(e.target.value);
        setSelectedRepairs({
            ...selectedRepairs,
            repairCost: !isNaN(cost) ? cost : ''
        });
    };

    const handleChangeAssignedPerson = (e) => {
        setSelectedRepairs({
            ...selectedRepairs,
            'assignedId': e?.id,
            'assignedName': e?.label,
        });
        setSelectedAssignedPerson(e);
    };

    const submitForm = (type) => {
        if (selectedRepairs?.repairTypeId === '') {
            toast.error('Please select a repair type');
            return;
        }
        if (selectedRepairs?.repairCost === undefined || selectedRepairs?.repairCost === '') {
            toast.error('Please enter the repair cost');
            return;
        }
        if (selectedRepairs?.assignedId === '') {
            toast.error('Please select an assigned person');
            return;
        }
        if (type === 'save') {
            handleAddRepairs(selectedRepairs);
            handleClose();
        } else {
            handleAddRepairs(selectedRepairs);
            setSelectedRepairType(null);
            setSelectedAssignedPerson(null);
            setSelectedRepairs({
                'operationItemId': selectedItem?.id,
                'repairTypeId': '',
                'repairName': '',
                'repairCurrency': currencies?.[0]?.value,
                'repairCost': '',
                'assignedId': '',
                'assignedName': '',
            });
        }
    };

    if (!openPopup) return null;

    return (
        <div
            className="d-flex"
            style={{
                width: '100vw',
                height: '100dvh',
                position: 'fixed',
                left: 0,
                top: 0,
                zIndex: 20,
                background: 'rgba(0,0,0,0.07)',
                justifyContent: 'center',
                alignItems: 'end',
                paddingBottom: '90px',
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)'
            }}
        >
            <div
                className="popup product-popup-mobile d-md-none"
                style={{
                    position: 'relative',
                    transform: 'none',
                    top: 0,
                    left: 0,
                    maxWidth: '90%',
                    background: '#fff',
                    borderRadius: 12,
                    boxShadow: 'rgb(0 0 0 / 37%) 0px 0px 20px',
                    width: '100%',
                    minHeight: '70dvh',
                    padding: '24px 16px 0 16px',
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                {/* Header */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12, position: 'relative' }}>
                    <div style={{ flex: 1, textAlign: 'center' }}>
                        <RepairIcon height={'60px'} width={'60px'} />
                        <div style={{ fontSize: '22px', fontWeight: 600, marginTop: 8 }}>Add Repairs</div>
                        <div style={{ fontSize: 14, color: '#888' }}>
                            Select the repairs you would like to add to this <br />
                            {selectedItem?.productName} {selectedItem?.colorName}{' '}
                            <div className="text-primary">IMEI: {selectedItem?.imei}</div>
                        </div>
                    </div>
                </div>

                <div style={{ flex: 1, overflowY: 'auto', paddingBottom: 16 }}>
                    <div className="form-group" style={{ marginBottom: 16 }}>
                        <label>Repairs Needed</label>
                        <Select
                            options={repairTypes}
                            className="rs-container"
                            classNamePrefix="rs"
                            placeholder="Select or type..."
                            isMulti={false}
                            onChange={handleChangeRepair}
                            value={selectedRepairType}
                        />
                    </div>
                    <div className="form-group" style={{ marginBottom: 16 }}>
                        <label>Repair Cost</label>
                        <InputGroup className="mb-3 d-flex">
                            <DropdownButton
                                variant="outline-secondary"
                                title={defaultCurrency}
                                id="input-group-dropdown-1"
                            >
                                {currencies.map((currency) => (
                                    <Dropdown.Item
                                        href="#"
                                        key={currency.value}
                                        onClick={() => handleChangeCurrency(currency)}
                                    >
                                        {currency.label}
                                    </Dropdown.Item>
                                ))}
                            </DropdownButton>
                            <input
                                type="text"
                                id="input-example"
                                name="input-name"
                                className="form-control"
                                placeholder="0.00"
                                onChange={handleChangeCost}
                                value={selectedRepairs?.repairCost}
                                autoComplete={'off'}
                                autoFocus
                            />
                        </InputGroup>
                    </div>
                    <div className="form-group" style={{ marginBottom: 16 }}>
                        <label>Assign to</label>
                        <Select
                            options={users}
                            className="rs-container"
                            placeholder="Select or type..."
                            classNamePrefix="rs"
                            isMulti={false}
                            isClearable={false}
                            onChange={handleChangeAssignedPerson}
                            value={selectedAssginedPerson}
                        />
                    </div>
                </div>

                <div
                    className="btnarea"
                    style={{
                        position: 'sticky',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        background: '#fff',
                        padding: '16px 0 12px 0',
                        zIndex: 30,
                        display: 'flex',
                        gap: 10,
                        justifyContent: 'center',
                        marginTop: 'auto'
                    }}
                >
                    <button
                        className="btn btn-main-primary btn-outlined-main"
                        disabled={!selectedRepairs}
                        onClick={() => submitForm('save')}
                    >
                        Save
                    </button>
                    <button
                        className="btn btn-main-primary btn-outlined-main"
                        disabled={!selectedRepairs}
                        onClick={() => submitForm('add')}
                    >
                        Save and Add
                    </button>
                    <button
                        className="btn btn-main-primary btn-outlined-main"
                        onClick={handleClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RepairModalMobile;
